import React, { useCallback } from 'react';

import { FiPlus } from 'react-icons/fi';

import { FaLongArrowAltRight, FaLongArrowAltLeft } from 'react-icons/fa';

import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import {
  ContainerMyPayment,
  MyPaymentTitle,
  PaymentMore,
  ContainerPaymentLists,
  ContainerPaymentItem,
  ContainerPaymentItemContent,
  PaymentItemSelected,
  PaymentItemClosed,
  PaymentItemAdd,
  PaymentItemAddLogo,
  PaymentItemAddText,
} from './styles';
import { StoreState } from '../../store/createStore';

import {
  userPaymentSelectedRequest,
  userPaymentRemovedRequest,
} from '../../store/modules/auth/actions';
import { useTranslation } from '../../hooks/useTranslation';
import ReactCreditCard from '../ReactCreditCard';

interface CardPaymentProps {
  title: string;
  summary?: boolean;
  nobtnNew?: boolean | false;
}

const CardPayment: React.FC<CardPaymentProps> = ({
  title,
  summary: summaryFlag,
  nobtnNew,
} : CardPaymentProps) => {
  const {onTranslation : t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    user: { methods },
  } = useSelector((state: StoreState) => state.auth);

  const handleRemoved = useCallback(payment_id => {
    if (payment_id !== undefined)
      dispatch(userPaymentRemovedRequest(payment_id));
  }, [dispatch]);

  const handlePayment = useCallback(
    summary_id => {
      if (summary_id !== undefined)
        dispatch(userPaymentSelectedRequest(summary_id));
    },
    [dispatch],
  );

  const handlePaymentADD = useCallback(() => {
    history.push('/account/payment');
  }, [history]);

  return (
    <ContainerMyPayment>
      <MyPaymentTitle>
        <PaymentMore>{!summaryFlag && <FaLongArrowAltLeft />}</PaymentMore>
        <span>{title}</span>
        <PaymentMore>
          <FaLongArrowAltRight />
        </PaymentMore>
      </MyPaymentTitle>
      <ContainerPaymentLists>
        <>
          {methods &&
            methods.map(method => (
                <ContainerPaymentItemContent key={method.id}>
                  <ContainerPaymentItem
                    onClick={() => handlePayment(method.id)}
                    selected={method.selected}
                  >
                    {method.selected === 1 && (
                      <PaymentItemSelected>
                        <AiOutlineCheck />
                      </PaymentItemSelected>
                    )}

                    <ReactCreditCard
                      expiration={method.expiry_date}
                      expirationAfter="validthru"
                      expirationBefore="month/year"
                      hasRadialGradient={false}
                      hasShadow={false}
                      name={method.full_name}
                      number={method.card_number}
                      placeholderName="FULL NAME"
                    />
                  </ContainerPaymentItem>
                  <PaymentItemClosed>
                    <AiOutlineClose
                      title={t('main.card_payment.remove')}
                      onClick={() => handleRemoved(method.id)}
                    />
                  </PaymentItemClosed>
                </ContainerPaymentItemContent>
            ))}
        </>
        {!nobtnNew && (
          <>
        <PaymentItemAdd onClick={handlePaymentADD}>
          <PaymentItemAddLogo>
            <FiPlus size="48" color="var(--green)" />
          </PaymentItemAddLogo>
          <PaymentItemAddText>
            <span>Adicionar Novo Pagamento</span>
          </PaymentItemAddText>
        </PaymentItemAdd>
        </>
        )}
      </ContainerPaymentLists>
    </ContainerMyPayment>
  );
};

export default CardPayment;
